/** Parse dock-station scans: arrived-package hex, unique inventory box URL, legacy inventory URL, or a SKU. */

import {
  parseInventoryBoxIdFromScan,
  parseLegacyInventoryAdjustmentUrl,
} from "../inventory-box/inventory-box-scan.js";
import { parseInboundArrivalPackageHex } from "./shipping-inbound-arrival-package-scan.js";

export type ParsedInboundStationScan =
  | { kind: "package_token"; hex: string }
  | { kind: "inventory_box"; hex: string }
  | { kind: "inventory_url"; sku: string; locationId: number }
  | { kind: "sku"; sku: string };

export function parseInboundStationScan(raw: string): ParsedInboundStationScan | null {
  const trimmed = raw.trim();
  if (trimmed === "") return null;

  const boxHex = parseInventoryBoxIdFromScan(trimmed);
  if (boxHex != null) {
    return { kind: "inventory_box", hex: boxHex };
  }

  const arrivalHex = parseInboundArrivalPackageHex(trimmed);
  if (arrivalHex != null) {
    return { kind: "package_token", hex: arrivalHex };
  }

  const legacy = parseLegacyInventoryAdjustmentUrl(trimmed);
  if (legacy != null) {
    return { kind: "inventory_url", sku: legacy.sku, locationId: legacy.locationId };
  }

  const sku = trimmed;
  if (sku.includes("/") || sku.includes(" ")) return null;
  if (sku.length < 2 || sku.length > 80) return null;
  return { kind: "sku", sku };
}
